import {setHours, setMinutes} from 'date-fns'
import moment from 'moment'
import React from 'react'
import DatePicker from 'react-datepicker'
import Iframe from 'react-iframe'
import {GeneralDataOFLoginUser} from '../../../../../Utils/Auth'
import {getAllUserDetails} from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useDispatch, useSelector} from 'react-redux'
import Select from 'react-select'
import {openPopup} from '../../../../../Components/PopupSlice/popupSlice'
import {useTimezone} from '../../../../../hooks/useTimezone'
import {useNewMessage} from '../../useNewMessage'

const Bulk_Message_when = ({
  isForwardIncomingMessage,
  setIsForwardIncomingMessage,
  bulkMessageData,
  setBulkMessageData,
  checkStep,
  error,
  setError,
}: any) => {
  const now = moment()
  const dispatch = useDispatch()
  const UserDetails = GeneralDataOFLoginUser()
  const userValues = useSelector(getAllUserDetails)
  const {getUserTimezoneNow, timezoneLabel} = useTimezone()
  const userTimezoneNow = getUserTimezoneNow()
  const {isDefaultRegion} = useNewMessage()

  const SingleWhen = () => {
    return (
      <>
        {bulkMessageData?.abTest ? <h5>Message A</h5> : null}
        <ul className='nav nav-tabs' id='myTab' role='tablist'>
          <li className='nav-item me-3 mb-3' role='presentation'>
            <button
              className='nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6'
              id='Now-tab'
              data-bs-toggle='tab'
              data-bs-target='#Now'
              type='button'
              role='tab'
              data-testid='btnSendNowA'
              aria-controls='Now'
              aria-selected='false'
              onClick={() => {
                let errorData = {...error}

                delete errorData.when
                setError(errorData)
                setBulkMessageData({...bulkMessageData, when: 'now', scheduledAt: new Date()})
              }}
            >
              Now
            </button>
          </li>

          <li className='nav-item me-3 mb-3' role='presentation'>
            <button
              className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${!isDefaultRegion && 'd-none'}`}
              id='Later-tab'
              data-bs-toggle='tab'
              data-bs-target='#Later'
              type='button'
              role='tab'
              data-testid='btnSendLaterA'
              aria-controls='Later'
              aria-selected='false'
              disabled={!isDefaultRegion}
              onClick={() => {
                setBulkMessageData({...bulkMessageData, when: 'later'})
              }}
            >
              Later
            </button>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          {userValues?.smsStatus === 'approved' && !bulkMessageData?.abTest && (
            <div
              className='tab-pane fade show active'
              id='Now'
              role='tabpanel'
              aria-labelledby='Now-tab'
            >
              <div className='when'>
                {isDefaultRegion && (
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input me-5'
                      id='stagger'
                      type='checkbox'
                      data-kt-check='true'
                      checked={bulkMessageData.staggerMessages}
                      onChange={() => {
                        setBulkMessageData({
                          ...bulkMessageData,
                          staggerMessages: !bulkMessageData.staggerMessages,
                        })
                      }}
                    />
                    <div>
                      <label htmlFor='stagger' style={{lineHeight: '0.65'}}>
                        Stagger messages
                      </label>
                      <p>
                        Set your messages to leave in batches at set intervals - control exposure!
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {isDefaultRegion && bulkMessageData.staggerMessages && (
                <div className='row'>
                  <div className='col-md-5'>
                    <Select
                      name='selector'
                      data-testid='ddSelectQuantity'
                      className='form-select bg-light-primary border-0  m-3 mb-0'
                      onChange={(e: any) => {
                        setBulkMessageData({
                          ...bulkMessageData,
                          quantity: e.value,
                        })
                      }}
                      placeholder='Select quantity'
                      options={[
                        {value: 10, label: 10},
                        {value: 20, label: 20},
                        {value: 50, label: 50},
                        {value: 100, label: 100},
                        {value: 150, label: 150},
                        {value: 500, label: 500},
                        {value: 1000, label: 1000},
                        {value: 10000, label: 10000},
                        {value: 25000, label: 25000},
                        {value: 50000, label: 50000},
                        {value: 100000, label: 100000},
                      ]}
                    />
                  </div>
                  <div className='col-md-5'>
                    <Select
                      name='selector'
                      onChange={(e: any) => {
                        setBulkMessageData({
                          ...bulkMessageData,
                          interval: e.value,
                        })
                      }}
                      placeholder='Select interval'
                      data-testid='ddSelectInterval'
                      className='form-select bg-light-primary border-0  m-3 mb-0'
                      options={[
                        {value: 5, label: '5 Minutes'},
                        {value: 10, label: '10 Minutes'},
                        {value: 20, label: '20 Minutes'},
                        {value: 60, label: '1 Hour'},
                        {value: 720, label: '12 Hour'},
                        {value: 1440, label: '24 Hour'},
                      ]}
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          <div className='tab-pane fade' id='Later' role='tabpanel' aria-labelledby='Later-tab'>
            <div className='when'>
              {bulkMessageData?.when == 'later' && (
                <div className='select-date col-sm-6 mb-5'>
                  <label htmlFor='' className='mb-2' data-testid='lblSelectDateA'>
                    Select Date & Time <span className=''>{timezoneLabel}</span>
                  </label>
                  <DatePicker
                    minDate={userTimezoneNow}
                    dateFormat='MMMM d, yyyy h:mm aa'
                    placeholderText='Select a date'
                    showTimeSelect
                    className='border-0 form-control form-control-lg form-control-solid col-md-6'
                    onChange={(e: any) => {
                      if (new Date(e) > getUserTimezoneNow()) {
                        let err = {...error}
                        delete err.late
                        delete err.when
                        setBulkMessageData({...bulkMessageData, scheduledAt: e})
                        setError({...err})
                      } else {
                        setBulkMessageData({...bulkMessageData, scheduledAt: e})
                        setError({
                          ...error,
                          late: 'Please select proper time to schedule message',
                          when: 'please select when',
                        })
                      }
                    }}
                    selected={bulkMessageData?.scheduledAt ? bulkMessageData?.scheduledAt : ''}
                  />
                  {error?.late ? (
                    <span className='text-danger'>
                      {error?.late}, current time is{' '}
                      {moment.tz(userTimezoneNow, moment.tz.guess()).format('MMMM D, yyyy hh:mm a')}
                    </span>
                  ) : (
                    <span className='text-muted text-sm mb-20'>
                      current time is{' '}
                      {moment.tz(userTimezoneNow, moment.tz.guess()).format('MMMM D, yyyy hh:mm a')}
                    </span>
                  )}
                </div>
              )}
              {userValues?.smsStatus === 'approved' && !bulkMessageData?.abTest && (
                <>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input me-5'
                      id='stagger'
                      type='checkbox'
                      data-kt-check='true'
                      checked={bulkMessageData.staggerMessages}
                      onChange={() => {
                        setBulkMessageData({
                          ...bulkMessageData,
                          staggerMessages: !bulkMessageData.staggerMessages,
                        })
                      }}
                    />
                    <div>
                      <label htmlFor='stagger' style={{lineHeight: '0.65'}}>
                        Stagger messages
                      </label>
                      <p>
                        Set your messages to leave in batches at set intervals - control exposure!
                      </p>
                    </div>
                  </div>
                  {bulkMessageData.staggerMessages && (
                    <div className='row'>
                      <div className='col-md-5'>
                        <Select
                          name='selector'
                          data-testid='ddSelectQuantity'
                          className='form-select bg-light-primary border-0  m-3 mb-0'
                          onChange={(e: any) => {
                            setBulkMessageData({
                              ...bulkMessageData,
                              quantity: e.value,
                            })
                          }}
                          placeholder='Select quantity'
                          options={[
                            {value: 10, label: 10},
                            {value: 20, label: 20},
                            {value: 50, label: 50},
                            {value: 100, label: 100},
                            {value: 150, label: 150},
                            {value: 500, label: 500},
                            {value: 1000, label: 1000},
                            {value: 10000, label: 10000},
                            {value: 25000, label: 25000},
                            {value: 50000, label: 50000},
                            {value: 100000, label: 100000},
                          ]}
                        />
                      </div>
                      <div className='col-md-5'>
                        <Select
                          placeholder='Select interval'
                          name='selector'
                          data-testid='ddSelectInterval'
                          onChange={(e: any) => {
                            setBulkMessageData({
                              ...bulkMessageData,
                              interval: e.value,
                            })
                          }}
                          className='form-select bg-light-primary border-0  m-3 mb-0'
                          options={[
                            {value: 5, label: '5 Minutes'},
                            {value: 10, label: '10 Minutes'},
                            {value: 20, label: '20 Minutes'},
                            {value: 60, label: '1 Hour'},
                            {value: 720, label: '12 Hour'},
                            {value: 1440, label: '24 Hour'},
                          ]}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {isDefaultRegion && bulkMessageData.camp_type === 'sms' && !bulkMessageData?.abTest && (
          <div className='mb-6 mt-6 mb-10 form-group'>
            <div
              className='col-12 mb-5 form-check form-check-sm form-check-custom form-check-solid '
              style={{marginTop: '0px !important'}}
            >
              <input
                className='form-check-input me-5'
                id='contact'
                data-testid='cbForwardReplyEmail'
                type={'checkbox'}
                onChange={(e) => {
                  setIsForwardIncomingMessage(!isForwardIncomingMessage)
                }}
                checked={isForwardIncomingMessage}
              />
              <label
                htmlFor='contact'
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                }}
              >
                Forwards incoming SMS
              </label>
            </div>
            {isForwardIncomingMessage && (
              <input
                type='text'
                data-testid='inputFormardedReplyEmail'
                value={bulkMessageData?.forwardReplyTo || ''}
                className='react-tagsinput-input form-control form-control-lg form-control-solid w-100'
                placeholder='targetemail1@mail.com, targetemail2@mail.com'
                onChange={(e) =>
                  setBulkMessageData({...bulkMessageData, forwardReplyTo: e.target.value})
                }
              />
            )}
          </div>
        )}
      </>
    )
  }

  const SecondWhen = () => {
    if (!bulkMessageData?.abTest) {
      return
    }

    return (
      <>
        <h5>Message B</h5>
        <ul className='nav nav-tabs' id='myTab' role='tablist'>
          <li className='nav-item me-3 mb-3' role='presentation'>
            <button
              className='nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6'
              id='Now-tab'
              data-bs-toggle='tab'
              data-bs-target='#Now'
              type='button'
              role='tab'
              data-testid='btnSendNowB'
              aria-controls='Now'
              aria-selected='false'
              onClick={() => {
                let errorData = {...error}

                delete errorData.whenSecond
                setError(errorData)
                setBulkMessageData({
                  ...bulkMessageData,
                  whenSecond: 'now',
                  scheduledAtSecond: new Date(),
                })
              }}
            >
              Now
            </button>
          </li>

          <li className='nav-item me-3 mb-3' role='presentation'>
            <button
              className='nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6'
              id='Later-tab-second'
              data-bs-toggle='tab'
              data-bs-target='#Later-second'
              type='button'
              data-testid='btnSendLaterB'
              role='tab'
              aria-controls='Later-second'
              aria-selected='false'
              onClick={() => {
                setBulkMessageData({...bulkMessageData, whenSecond: 'later'})
              }}
            >
              Later
            </button>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          <div
            className='tab-pane fade'
            id='Later-second'
            role='tabpanel'
            aria-labelledby='Later-tab-second'
          >
            <div className='when'>
              {bulkMessageData?.whenSecond == 'later' && (
                <div className='select-date col-sm-6 mb-5'>
                  <label htmlFor='' className='mb-2' data-testid='lblSelectDateB'>
                    Select Date & Time{' '}
                    <span className=''>{timezoneLabel}</span>
                  </label>
                  <DatePicker
                    minDate={userTimezoneNow}
                    dateFormat='MMMM d, yyyy h:mm aa'
                    placeholderText='Select a date'
                    showTimeSelect
                    className='border-0 form-control form-control-lg form-control-solid col-md-6'
                    onChange={(e: any) => {
                      if (new Date(e) > getUserTimezoneNow()) {
                        let err = {...error}
                        delete err.late
                        delete err.when
                        setBulkMessageData({...bulkMessageData, scheduledAtSecond: e})
                        setError({...err})
                      } else {
                        setBulkMessageData({...bulkMessageData, scheduledAtSecond: e})
                        setError({
                          ...error,
                          lateSecond: 'Please select proper time to schedule message',
                          whenSecond: 'please select when',
                        })
                      }
                    }}
                    selected={
                      bulkMessageData?.scheduledAtSecond ? bulkMessageData?.scheduledAtSecond : ''
                    }
                  />
                  {error?.lateSecond ? (
                    <span className='text-danger'>
                      {error?.lateSecond}, current time is{' '}
                      {moment.tz(userTimezoneNow, moment.tz.guess()).format('MMMM D, yyyy h:mm a')}
                    </span>
                  ) : (
                    <span className='text-muted text-sm mb-20'>
                      current time is{' '}
                      {moment.tz(userTimezoneNow, moment.tz.guess()).format('MMMM D, yyyy h:mm a')}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    )
  }
  return (
    <>
      <h2 className={`accordion-header ${bulkMessageData.when && 'successData'}`} id='headingfive'>
        <button
          className='accordion-button collapsed'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapsefive'
          aria-expanded='false'
          aria-controls='collapsefive'
        >
          When
        </button>
        <div className='bulk-message-collapse'>
          {bulkMessageData?.abTest ? (
            <div className='accordion-title-detail small'>Message A: </div>
          ) : null}
          <div className='accordion-title-detail small'>When: {bulkMessageData?.when}</div>

          {bulkMessageData?.abTest ? (
            <>
              <div className='accordion-title-detail small'>Message B: </div>
              <div className='accordion-title-detail small'>
                When: {bulkMessageData?.whenSecond}
              </div>
            </>
          ) : null}
        </div>
      </h2>
      <div
        id='collapsefive'
        className={`accordion-collapse collapse ${checkStep.when && 'show'}`}
        aria-labelledby='headingfive'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <>
            {SingleWhen()}

            {SecondWhen()}
          </>
        </div>
      </div>
    </>
  )
}

export default Bulk_Message_when
